module.exports = __webpack_public_path__ + "img/trashicon.a9526eac.png";